import ResponseRow from '@app/src/pages/ResourceCollection/Collections/Response/AccessorResponseRow'
import ResponseHeader from '@app/src/pages/ResourceCollection/Collections/Response/AccessorResponseHeader'
import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { RESPONSE_LATEST_SUBMITTED_FILTER } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import type { ResourceCollectionSceneProps } from '@app/src/pages/ResourceCollection/ResourceCollectionScene'
import React from 'react'
import BaseAccessorResponseScene from './BaseAccessorResponseScene'

interface AccessorResponseSceneProps {
  relatedContentFilter?: FilterGroup[]
  embedded?: boolean
  tabs?: ResourceCollectionSceneProps['tabs']
  actionButtons?: ResourceCollectionSceneProps['actionButtons']
}

const AccessorResponseScene: React.FC<AccessorResponseSceneProps> = props => {
  return (
    <BaseAccessorResponseScene
      {...props}
      relatedContentFilter={[...(props.relatedContentFilter ?? []), RESPONSE_LATEST_SUBMITTED_FILTER]}
      RowComponent={ResponseRow}
      HeaderComponent={ResponseHeader}
    />
  )
}

export default AccessorResponseScene
